import { ReactComponentElement } from 'react';
import PropTypes from 'prop-types';
import { Text } from 'roo-ui/components';
import { TextStyleProps } from 'styled-system';

interface HeaderProps extends TextStyleProps {
  message: string | ReactComponentElement<any>;
}

const Header = ({ message, ...props }: HeaderProps) => (
  <Text fontSize={['2xl', '3xl']} fontWeight="bold" textAlign="center" {...props}>
    {message}
  </Text>
);

Header.propTypes = {
  message: PropTypes.string.isRequired,
  ...Text.propTypes,
};

export default Header;
